<template>
  <div class="px-2 py-2 bg-surface-ground">
    <div class="text-center my-5">
      <h2 class="text-3xl md:text-5xl font-bold">FAQ</h2>
    </div>

    <Accordion expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
      <AccordionTab v-for="(faq, index) in faqs" :key="index" :header="faq.question">
        <p class="faq-answer" v-html="faq.answer" />
      </AccordionTab>
    </Accordion>
  </div>
</template>

<script setup>
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'

const faqs = [
  {
    question: 'How does Askodds work ?',
    answer:
      'Build your bet with one or more selections, you can type or speak a selection. Review the best odds from different Bookmakers. Optionally share your bet, even before placing to discuss with friends and build together. Place your bet by going to bet slip for the current bet at any time.',
  },
  {
    question: 'Where can I use ask odds ?',
    answer:
      'Ask odds is a web application supported by all major browsers and platforms. Mobile and desktop.',
  },
  {
    question: 'How do I get to ask odds ?',
    answer:
      'Save the website to your home page when prompted to. On iOS add to home screen from the phones share feature',
  },
  {
    question: 'What can I bet on ?',
    answer: 'Currently major football and horse racing is supported. More markets coming soon.',
  },
  {
    question: 'What bookmakers do you use ?',
    answer:
      'Working with 20+ bookmaker (Paddy Power, Sky Bet, Unibet, Betway, BetMGM, Boylesports, William Hill, Corals, Bet Victor, Ladbrokes, Leovegas, Fanduel, Draft Kings Points Bet, 888 Sport, Bet Rivers, Virgin Bet, with more coming soon.',
  },
  {
    question: 'How can change what odds and bookmakers I see ?',
    answer:
      'Yes, open the preferences from the menu. Select the regions and bookmakers you are interested in. Exclude any you are not interested in.',
  },
  {
    question: 'I am an affiliate how can this work for me?',
    answer:
      'Askodds is perfect for affiliates. Contact us to discuss. Email us <a href="mailto:info@voxbet.com">info@voxbet.com</a>',
  },
  {
    question: 'How to contact us?',
    answer: 'Email us <a href="mailto:info@voxbet.com">info@voxbet.com</a>',
  },
]
</script>

<style scoped>
.faq-answer {
  line-height: 1.6;
  color: #acacaf;
}

/* Expanded content */
::v-deep(.p-accordioncontent-content) {
  background-color: #3f3f46;
}

/* Inactive title while NOT hovering */
::v-deep(.p-accordionheader) {
  background-color: #18181b;
  color: #acacaf;
}

/* Inactive title while hovering */
::v-deep(
  .p-accordionpanel:not(.p-accordionpanel-active):not(.p-disabled) > .p-accordionheader:hover
) {
  background-color: #444444;
  color: white;
}

/* Active title while NOT hovering */
::v-deep(.p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader) {
  background-color: #3f3f46;
  color: white;
}

/* Active title while hovering */
::v-deep(.p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader:hover) {
  background-color: #3f3f46;
  color: white;
}
</style>
